import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchBlog } from "@/lib/api";
import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { fetchBlog().then(setPosts); }, []);
  return (
    <div className="pt-28 pb-24 bg-brand-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <div className="text-center mb-14">
            <div className="divider-gold">Insights</div>
            <h1 className="mt-4 font-serif text-5xl lg:text-6xl text-brand-navy">Wilshire Journal</h1>
            <p className="mt-3 text-brand-charcoal/70">Market insights, buyer guides & industry updates from our advisors.</p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 60}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block bg-white border border-brand-gold/20 overflow-hidden h-full hover:shadow-md transition-shadow">
                <div className="aspect-[16/10] overflow-hidden bg-brand-cream">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                </div>
                <div className="p-6">
                  <div className="flex gap-2 flex-wrap mb-2">
                    {(p.tags || []).slice(0, 2).map(t => <span key={t} className="text-[10px] tracking-widest uppercase text-brand-gold">{t}</span>)}
                  </div>
                  <h3 className="font-serif text-2xl text-brand-navy leading-snug group-hover:text-brand-gold transition-colors">{p.title}</h3>
                  <p className="mt-3 text-sm text-brand-charcoal/70 line-clamp-3">{p.excerpt}</p>
                  <div className="mt-4 text-xs text-brand-gold flex items-center gap-1">Read more <ArrowRight size={12} /></div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
